import { useEffect } from 'react';
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../store';
import { ISession } from '../../models/pro-sites';

interface IPageTitleProps {
    session: ISession;
    pageTitleId?: string;
    title?: string;
}

export const PageTitle = ({ session, pageTitleId, title }: IPageTitleProps) => {
    const intl = useIntl();
    useEffect(() => {
        const previousTitle = document.title;
        const pageTitle = pageTitleId
            ? intl.formatMessage({ id: pageTitleId })
            : title!;
        document.title = pageTitle + ' | ' + session!.title;
        return () => {
            document.title = previousTitle;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

const mapStateToProps = (state: RootState) => {
    return {
        session: state.session!.data!,
    };
};

const container = connect(mapStateToProps)(PageTitle);

export default container;
